import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;
// const API_BASE_URL = process.env.REACT_APP_API_URL;
// const API_BASE_URL = "http://192.168.0.93:8000/api/v2/attesta/";

// src/global.jsx

const fetchOptionsInsights = async () => {
  try {
    const response = await axios.post(API_BASE_URL + "Ins_User_info", {
      mode: "InsightPage"
    });

    const allInsights = response.data || [];
    
    if (allInsights?.data?.length > 0) {
      return allInsights.data;
    }

    return []; // fallback
  } catch (error) {
    console.error("Error fetching insights:", error);
    return []; // fallback on error
  }
};

const fetchOptionsPlans = async () => {
  try {
    const response = await axios.get(API_BASE_URL + "plans");

    const allPlans = response.data || [];
    
    if (allPlans?.data?.length > 0) {
      return allPlans.data || [];
    }

    return []; // fallback
  } catch (error) {
    console.error("Error fetching plans:", error);
    return []; // fallback on error
  }
};




export { API_BASE_URL, fetchOptionsInsights, fetchOptionsPlans };